import { DefaultPageHeader } from 'layouts';
import { Card, Skeleton } from 'ui';
import { GivingsSlider, useGivingsInfiniteQuery } from 'features/givings';
import { ChannelsEmpty, EntityList } from '../components';
import { useOrganizationRequestContent } from '../hooks';

type P = {
  getPathToGivingDetail: (id: string) => string;
  navigateToGivings: () => Promise<void>;
  organizationId: string;
};

const ChannelsGivings = ({ getPathToGivingDetail, navigateToGivings, organizationId }: P) => {
  const { allOrganizations, isLoadingOrganizations, requestOrganizationId } = useOrganizationRequestContent({
    organizationId,
  });

  const {
    data: allGivingsData,
    fetchNextPage,
    hasNextPage,
    isFetching: isFetchingAll,
    isLoading: isLoadingAll,
  } = useGivingsInfiniteQuery({
    filter: {
      organizationId: requestOrganizationId,
      scope: 'channels',
    },
    pagination: { pageSize: 12 },
  });

  const allGivings = allGivingsData?.pages.flat().flatMap((givingsPaginated) => givingsPaginated.data);

  return (
    <>
      <DefaultPageHeader title="Giving" />
      {isLoadingOrganizations || isLoadingAll || !allGivings || !allOrganizations ? (
        <Skeleton active paragraph={{ rows: 16 }} />
      ) : (
        <>
          <GivingsSlider
            controls={{ title: 'Featured' }}
            getPathToGivingDetail={getPathToGivingDetail}
            query={{ filter: { featured: true, organizationId: requestOrganizationId, scope: 'channels' } }}
          />
          <Card title={<Card.Title level={2}>All</Card.Title>}>
            <EntityList
              empty={<ChannelsEmpty navigateToJoined={navigateToGivings} scope="givings" />}
              entities={allGivings.map((giving) => ({
                data: giving,
                type: 'Giving',
              }))}
              fetchNextPage={fetchNextPage}
              getPathToEntityDetail={getPathToGivingDetail}
              hasNextPage={hasNextPage}
              isFetching={isFetchingAll}
              isLoading={isLoadingAll}
            />
          </Card>
        </>
      )}
    </>
  );
};

export default ChannelsGivings;
